<div
  class="gradient-container"
  (pointerdown)="pickColorFromGradient($event); mouseDownGradient = true"
  (pointermove)="pickColorFromGradient($event)"
  (pointerenter)="pointerEnterGradient($event)"
  (pointerup)="mouseDownGradient = false"
  (pointerleave)="mouseDownGradient = false"
  [class.mouse-down]="mouseDownGradient"
>
  <canvas #gradient width="280" height="150"></canvas>
  <div class="gradient-position-container">
    <div
      class="gradient-position"
      [style.left]="gradientPosition.x * 100 + '%'"
      [style.top]="gradientPosition.y * 100 + '%'"
    ></div>
  </div>
</div>
<div class="hue-row">
  <div
    class="eye-dropper"
    [style.backgroundColor]="color"
    [class.dark-bg]="color | isDarkColor"
    (click)="startEyeDropper()"
  >
    @if (allowEyeDropper) {
    <app-svg src="/assets/icons/pipette.svg"></app-svg>
    }
  </div>
  <div class="bars-container">
    <div class="hue-selector-container">
      <div
        class="hue-selector"
        (pointerdown)="pickHueFromSelector($event); mouseDownHue = true"
        (pointermove)="pickHueFromSelector($event)"
        (pointerenter)="pointerEnterHue($event)"
        (pointerup)="mouseDownHue = false"
        (pointerleave)="mouseDownHue = false"
        [class.mouse-down]="mouseDownHue"
        #hueEl
      >
        <div class="hue-position" [style.left]="(hue / 360) * 100 + '%'"></div>
      </div>
    </div>
    @if (allowOpacity) {
    <div
      class="opacity-selector-container"
      [style.--opacity-color]="'rgb(' + rgba.r + ',' + rgba.g + ',' + rgba.b + ')'"
    >
      <div
        class="opacity-selector"
        (pointerdown)="pickOpacityFromSelector($event); mouseDownOpacity = true"
        (pointermove)="pickOpacityFromSelector($event)"
        (pointerenter)="pointerEnterOpacity($event)"
        (pointerup)="mouseDownOpacity = false"
        (pointerleave)="mouseDownOpacity = false"
        [class.mouse-down]="mouseDownOpacity"
        #opacityEl
      >
        <div class="opacity-position" [style.left]="rgba.a * 100 + '%'"></div>
      </div>
    </div>
    }
  </div>
</div>
<form [formGroup]="form">
  <app-input-field
    [control]="form.controls.hex"
    [noLabel]="true"
    [smallNoLabel]="true"
    [noPreSpacing]="true"
    class="headless"
  >
    <div *appInputPre class="pre-hash">#</div>
    <input formControlName="hex" placeholder="HEX" />
  </app-input-field>
  @if (allowOpacity) {
  <app-input-field
    [control]="form.controls.opacity"
    [noLabel]="true"
    [smallNoLabel]="true"
    [noLabelExtraSpacing]="true"
    class="headless"
  >
    <input type="number" min="0" max="100" formControlName="opacity" placeholder="Opacity" />
    <div *appInputPost class="post-percent">%</div>
  </app-input-field>
  }
</form>
